export const mobileMixin = {
  computed: {
    mobileDevicesRegex() {
      return [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i,
      ];
    },
  },
};

export default {mobileMixin};
